<template>
  <div class="register">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="80px"
      class="register_form"
    >
      <el-form-item label="旧密码" prop="oldpassword">
        <el-input v-model="ruleForm.oldpassword" type="password" placeholder="请输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newpassword">
        <el-input v-model="ruleForm.newpassword" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="repassword">
        <el-input v-model="ruleForm.repassword" type="password" placeholder="再次输入新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="submitBtn" @click="updateSubmit">保存修改</el-button>
        <el-button @click="closeModal(false)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { updatePwd } from '@/libs/api'
export default {
  data() {
    var repasswordCheck = (rule, value, callback) => {
      if (value != this.ruleForm.newpassword || value == '') {
        callback(new Error('两次填入的密码需要保持一致'))
      } else {
        callback()
      }
    };
    return {
      ruleForm: {
        oldpassword: '',
        newpassword: '',
        repassword: '',
      },
      rules: {
        oldpassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newpassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        repassword: [
          { required: true, validator: repasswordCheck, trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    updateSubmit: function () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          updatePwd(this.ruleForm.oldpassword, this.ruleForm.newpassword).then(res => {
            if (res.status) {
              this.$alert('密码修改成功, 请退出重新登录。', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$store.dispatch('logout').then((value) => {
                    if (value) {
                      this.closeModal(true);
                      this.$router.push({ name: 'login' })
                    }
                  });
                }
              });
            } else {
              this.$alert('修改失败，' + res.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
            }
          });
        }
      })
    },
    closeModal: function (outValue) {
      this.$emit("close", outValue)
    }
  }
}
</script>
<style lang="less" scoped>
.submitBtn {
  background-color: #ae0c2a;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/tab/update/updatePwd.vue